import {StateType} from '@/types'
import {Module} from 'vuex'

const state = {
  shopcarNums: 0,
  shipProducts: [],
  buyNowData: null,
  orderCountsNum: {}
}
type ProductsStateType = typeof state

const products: Module<ProductsStateType, StateType> = {
  namespaced: true,
  ...state,
}

export {ProductsStateType, state}
export default products
